import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Message } from '@paypalcorp/worldready-react'
import { HeadingText, BodyText, Button, ReturnRightIcon } from '@paypalcorp/pp-react'
import { CreditAppEndStatuses } from '@paypalcorp/xo-credit-app-interface'
import { signalAppEnded } from '../../initializeApp'
import useAnalytics from '@/hooks/useAnalytics'
import XO_PPDC_FPTI_TAGS from '@/constants/fpti-tags/xo-ppdc'
import { noOffersCss } from './styles'
import { PPDCXO_CONSTANTS } from '@/constants/ppdcxo'
import { selectXoPPDCContent } from '@/features/enroll-card/enroll-card-slice'


const { errorCtaClickTags, upsellErrorScreenImpressionTags } = XO_PPDC_FPTI_TAGS

const ErrorPage = ({ reason = 'unknown' }) => {

  const xoPPDCData = useSelector(selectXoPPDCContent)
  const { xt, xe, instrumentationData } = xoPPDCData || {}

  const { recordClientClick } = useAnalytics({
    ...upsellErrorScreenImpressionTags,
    entry_point: PPDCXO_CONSTANTS.ENTRY_POINT,
    url_path: PPDCXO_CONSTANTS.URL_PATH,
    productName: PPDCXO_CONSTANTS.PRODUCT_NAME,
    errorDescription: reason,
    xt,
    xe,
    instrumentationData,
  })

  const handlePayAnotherWay = () => {
    recordClientClick({
      ...errorCtaClickTags,
      entry_point: PPDCXO_CONSTANTS.ENTRY_POINT,
      url_path: PPDCXO_CONSTANTS.URL_PATH,
      productName: PPDCXO_CONSTANTS.PRODUCT_NAME,
      xt,
      xe,
      instrumentationData,
    })
    if (window.ppdcHandlers?.signalDeclined) {
      window.ppdcHandlers.signalDeclined()
    } else {
      // Fallback
      signalAppEnded({ status: CreditAppEndStatuses.declined })
    }
  }


  return (
    <div css={noOffersCss}>
      <ReturnRightIcon />
      <HeadingText size="sm">
        <Message id="rewards.ppdcXo.error.header" />
      </HeadingText>
      <BodyText className="subtitle">
        <Message id="rewards.ppdcXo.error.content" />
      </BodyText>

      <div id="pay-another-way">
        <Button data-testid="pay-another-way-button" onClick={handlePayAnotherWay}>
          <Message id="rewards.ppdcXo.error.button" />
        </Button>
      </div>
    </div>
  )
}

ErrorPage.propTypes = {
  reason: PropTypes.string,
}

export default ErrorPage;
